import type { ToolMeta } from './registry';

export const searchWeddingSuppliersMeta = {
  description:
    "Searches Bridebook's supplier directory by type, location, and budget. Supports all UK supplier categories.",
  examples: [
    'Find photographers near London under £3000',
    'Show me wedding venues in Surrey for 100 guests',
    'Search for florists in Manchester',
  ],
  value: 'suppliers and venues that fit them, in their own area',
  grounding: 'venue',
  // A venue search needs the most inputs (a guest count), and is what couples ask for most.
  strictestArgs: { type: 'venue' },
} as const satisfies ToolMeta;
